import { render, staticRenderFns } from "./manualCuttingStationView.vue?vue&type=template&id=2bff40b6&scoped=true&"
import script from "./manualCuttingStationView.vue?vue&type=script&lang=js&"
export * from "./manualCuttingStationView.vue?vue&type=script&lang=js&"
import style0 from "./manualCuttingStationView.vue?vue&type=style&index=0&id=2bff40b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bff40b6",
  null
  
)

export default component.exports